import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import axiosClient from "../Services/Axios/axios";
import Swal from "sweetalert2";
import ImageUploader from "../pages/common/ImageUploader";
import { ClipLoader } from "react-spinners";
import PhoneInput from "react-country-phone-input";
import SellerSidebar from "./common/SellerSidebar";
import ProfileSidebar from "../pages/common/ProfileSidebar";

const SellerProfile = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [userNewData, setUserNewData] = useState({});
  const [profileImage, setProfileImage] = useState(null);
  const [bannerImage, setBannerImage] = useState(null);
  const [companyImage, setCompanyImage] = useState(null);
  const [companyLogo, setCompanyLogo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [profileData, setProfileData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    phoneCode: "",
    organization_mobile_no: "",
    organization_mobileCode: "",
    fullPhone: "",
    fullMobile: "",
    gender: "",
    dob: startDate,
    referral_code: "",
    role_type: "5",
    company_name: "",
    organization_name: "",
    organization_email: "",
    profile_image: "",
    banner_image: "",
    organization_location: "",
    organization_website: "",
    platform: "",
    social_media: [{ name: "Facebook", value: "" }],
    about_organization: "",
    company_image: "",
    company_logo: "",
  });
  const [errors, setErrors] = useState({});
  const [errorsValidation, setErrorsValidation] = useState({});
  /** ----------------------------
   * Handlers
   ---------------------------- */
  const handleDateChange = (date) => {
    setStartDate(date.target.value);
    setProfileData({
      ...profileData,
      dob: date.target.value,
    });
  };

  const handlePhoneChange = (value, country) => {
    setProfileData({
      ...profileData,
      fullPhone: value,
      phone: value.slice(country.dialCode.length),
      phoneCode: `+${country.dialCode}`,
    });
  };

  const handleMobileChange = (value, country) => {
    setProfileData({
      ...profileData,
      fullMobile: value,
      organization_mobile_no: value.slice(country.dialCode.length),
      organization_mobileCode: `+${country.dialCode}`,
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    let formIsValid = true;
    let errors = {};

    /** ----------------------------
     * Validations
     ---------------------------- */
    if (!profileData.first_name) {
      formIsValid = false;
      errors.first_name = "First name is required";
    } else if (profileData.first_name.length > 50) {
      formIsValid = false;
      errors.first_name = "First name cannot exceed 50 characters";
    }

    if (!profileData.last_name) {
      formIsValid = false;
      errors.last_name = "Last name is required";
    } else if (profileData.last_name.length > 50) {
      formIsValid = false;
      errors.last_name = "Last name cannot exceed 50 characters";
    }

    if (!profileData.organization_name) {
      formIsValid = false;
      errors.organization_name = "Organisation name is required";
    }

    if (!profileData.company_name) {
      formIsValid = false;
      errors.company_name = "Company name is required";
    }

    if (!profileData.email) {
      formIsValid = false;
      errors.email = "Email address is required";
    } else if (!/\S+@\S+\.\S+/.test(profileData.email)) {
      formIsValid = false;
      errors.email = "Email address is invalid";
    }

    if (!profileData.organization_email) {
      formIsValid = false;
      errors.organization_email = "Organization email is required";
    } else if (!/\S+@\S+\.\S+/.test(profileData.organization_email)) {
      formIsValid = false;
      errors.organization_email = "Organization email is invalid";
    }

    if (!profileData.phone) {
      formIsValid = false;
      errors.phone = "Phone number is required";
    }

    if (!profileData.organization_mobile_no) {
      formIsValid = false;
      errors.organization_mobile_no = "Organization mobile number is required";
    }

    if (!profileData.gender) {
      formIsValid = false;
      errors.gender = "Gender is required";
    }

    if (!profileData.organization_website) {
      formIsValid = false;
      errors.organization_website = "Website is required";
    }

    if (!profileData.about_organization) {
      formIsValid = false;
      errors.about_organization = "About organization is required";
    }

    if (!profileData.organization_location) {
      formIsValid = false;
      errors.organization_location = "Organization location is required";
    }

    if (!profileData.dob) {
      formIsValid = false;
      errors.dob = "Date of birth is required";
    }

    if ([8, 9].includes(+userNewData?.role_type)) {
      if (!profileData.company_name) {
        formIsValid = false;
        errors.company_name = "Please provide a Company or NGO name";
      }
    }
    setErrorsValidation(errors);
    if (!formIsValid) return;

    /** ----------------------------
     * API Call
     ---------------------------- */
    try {
      setLoading(true);
      const user = JSON.parse(localStorage.getItem("userData"));
      const response = await axiosClient.put("company/update-company-details", {
        ...profileData,
        user_id: user.id,
        profile_image: profileImage,
        organization_banner_image: bannerImage,
        company_image: companyImage,
        company_logo: companyLogo,
        social_media_name: profileData.social_media.map((item) => item.name),
        social_media_value: profileData.social_media.map((item) => item.value),
        user_role_type: +profileData.role_type,
      });

      if (!response.data.error) {
        Swal.fire({
          icon: "success",
          title: "User profile updated successfully.",
        });
        handleProfile();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed to update profile",
        text: error?.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };
  const handleProfile = async () => {
    const response = await axiosClient.get(
      `/users/${process.env.REACT_APP_API_VERSION}/getByID`
    );
    if (!response.data.error) {
      localStorage.setItem("userData", JSON.stringify(response.data.data));
    }
  };
  const uploadFile = async (file, onSuccess) => {
    try {
      const maxFileSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxFileSize) {
        Swal.fire({
          icon: "error",
          title: "File size exceeds 5MB",
          text: "Please upload a file smaller than 5MB.",
        });
        return;
      }

      const formData = new FormData();
      formData.append("image", file);

      const response = await axiosClient.post("users/uploadimg", formData);
      if (!response.data.error) {
        onSuccess(response.data.file);
      } else {
        Swal.fire({
          icon: "error",
          title: "Upload failed",
          text: response.data.message || "Something went wrong!",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Upload failed",
        text: error.message || "Something went wrong!",
      });
    }
  };

  // 🔥 Common handler
  const handleFileChange = (e, setState) => {
    const file = e.target.files[0];
    if (file) {
      uploadFile(file, (uploadedFile) => {
        setState(uploadedFile);
      });
    }
  };

  const runAfterImageDelete = (file) => {
    console.log("Deleted File:", file);
  };

  const handleSocialMediaChange = (index, field, value) => {
    const updatedSocialMedia = profileData.social_media.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );
    setProfileData((prevState) => ({
      ...prevState,
      social_media: updatedSocialMedia,
    }));
    setErrors((prevState) => {
      const updatedErrors = { ...prevState };
      updatedErrors[`social_media_${index}_${field}`] = "";
      return updatedErrors;
    });
  };

  const addSocialMediaField = (e) => {
    e.preventDefault();
    if (profileData.social_media.length < 11) {
      setProfileData({
        ...profileData,
        social_media: [
          ...profileData.social_media,
          { name: "Facebook", value: "" },
        ],
      });
    } else {
      Swal.fire({
        icon: "warning",
        title: "Limit Reached",
        text: "You can only add up to 10 social media links.",
      });
    }
  };

  const removeSocialMediaField = (index) => {
    if (profileData.social_media.length > 1) {
      const updatedSocialMedia = profileData.social_media.filter(
        (_, i) => i !== index
      );
      setProfileData({ ...profileData, social_media: updatedSocialMedia });
    }
  };

  /** ----------------------------
   * Effects
   ---------------------------- */
  useEffect(() => {
    const storedUser = localStorage.getItem("userData");
    if (storedUser) setUserNewData(JSON.parse(storedUser));
  }, []);

  useEffect(() => {
    if (userNewData) {
      const socialData = userNewData?.social_media || [];
      setProfileData((prev) => ({
        ...prev,
        first_name: userNewData?.first_name || "",
        last_name: userNewData?.last_name || "",
        email: userNewData?.email || "",
        phone: userNewData?.phone || "",
        phoneCode: userNewData?.phoneCode || "",
        fullPhone: userNewData?.phoneCode
          ? `${userNewData?.phoneCode} ${userNewData?.phone}`
          : "",
        gender: userNewData?.gender || "",
        dob: userNewData?.dob || startDate,
        referral_code: userNewData?.referral_code || "",
        profile_image: userNewData?.profile_image || "",
        banner_image: userNewData?.banner_image || "",
        role_type: userNewData?.role_type || "5",
        company_name: userNewData?.company_name || "",
        organization_name: userNewData?.organization?.organization_name || "",
        organization_email: userNewData?.organization?.organization_email || "",
        organization_mobile_no:
          userNewData?.organization?.organization_mobile_no || "",
        organization_mobileCode:
          userNewData?.organization?.organization_mobileCode || "",
        fullMobile: userNewData?.organization?.organization_mobileCode
          ? `${userNewData?.organization?.organization_mobileCode} ${userNewData?.organization?.organization_mobile_no}`
          : "",
        organization_location:
          userNewData?.organization?.organization_location || "",
        organization_website:
          userNewData?.organization?.organization_website || "",
        about_organization: userNewData?.organization?.about_organization || "",
        social_media:
          socialData.length > 0
            ? socialData.map((item) => ({
                name: item.social_media_text,
                value: item.website_url,
              }))
            : [{ name: "Facebook", value: "" }],
      }));
      setProfileImage(userNewData?.profile_image || null);
      setBannerImage(
        userNewData?.organization?.organization_banner_image || null
      );
      setCompanyImage(userNewData?.organization?.company_image || null);
      setCompanyLogo(userNewData?.organization?.company_logo || null);
    }
  }, [userNewData]);
  return (
    <>
      <div className="all_suport_bg manages_top">
        <section className="ser_v_araeea profiles">
          <div className="container">
            <div className="bradcams">
              <span className="bothss">
                <Link to="">My Account</Link>{" "}
                <img src="/images/brd_rowwo.png" alt="" /> Profile
              </span>
            </div>
            <div className="row">
              <div className="col-lg-3 mb_view_hide">
                <SellerSidebar />
              </div>

              {/* Seller Profile */}
              <div className="col-lg-9">
                <div className="form_boxx profilss">
                  <div className="form_arar mt-0">
                    <form onSubmit={handleUpdate}>
                      <h4>Profile</h4>

                      {/* ---------------- Profile Section ---------------- */}
                      <div className="mang_und_listst mt-0">
                        <div className="row">
                          <div className="col-lg-9">
                            <div className="row">
                              {/* First Name */}
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <label>First Name</label>
                                  <input
                                    maxLength={50}
                                    type="text"
                                    className={`form-control ${
                                      errorsValidation.first_name
                                        ? "input-error"
                                        : ""
                                    }`}
                                    value={profileData.first_name || ""}
                                    onChange={(e) => {
                                      setErrorsValidation({
                                        ...errorsValidation,
                                        first_name: "",
                                      });
                                      setProfileData({
                                        ...profileData,
                                        first_name: e.target.value,
                                      });
                                    }}
                                    placeholder="Enter first name"
                                  />
                                  {errorsValidation.first_name && (
                                    <div className="error">
                                      {errorsValidation.first_name}
                                    </div>
                                  )}
                                </div>
                              </div>

                              {/* Last Name */}
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <label>Last Name</label>
                                  <input
                                    maxLength={50}
                                    type="text"
                                    className={`form-control ${
                                      errorsValidation.last_name
                                        ? "input-error"
                                        : ""
                                    }`}
                                    value={profileData.last_name || ""}
                                    onChange={(e) => {
                                      setErrorsValidation({
                                        ...errorsValidation,
                                        last_name: "",
                                      });
                                      setProfileData({
                                        ...profileData,
                                        last_name: e.target.value,
                                      });
                                    }}
                                    placeholder="Enter last name"
                                  />
                                  {errorsValidation.last_name && (
                                    <div className="error">
                                      {errorsValidation.last_name}
                                    </div>
                                  )}
                                </div>
                              </div>

                              {/* Email */}
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <label>Email Address</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={profileData.email || ""}
                                    readOnly
                                    style={{ cursor: "not-allowed" }}
                                    placeholder="Enter email address"
                                  />
                                </div>
                              </div>

                              {/* Mobile No */}
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <label>Mobile No.</label>
                                  <PhoneInput
                                    className={`react-tel-input ${
                                      errorsValidation.phone
                                        ? "input-error"
                                        : ""
                                    }`}
                                    placeholder="Enter Phone Number"
                                    country={"th"}
                                    value={profileData.fullPhone || "+66"}
                                    onChange={(value, country) => {
                                      setErrorsValidation({
                                        ...errorsValidation,
                                        phone: "",
                                      });
                                      handlePhoneChange(value, country);
                                    }}
                                  />
                                  {errorsValidation.phone && (
                                    <div className="error">
                                      {errorsValidation.phone}
                                    </div>
                                  )}
                                </div>
                              </div>

                              {/* Gender */}
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <label>Gender</label>
                                  <select
                                    className={`form-control ${
                                      errorsValidation.gender
                                        ? "input-error"
                                        : ""
                                    }`}
                                    value={profileData.gender || ""}
                                    onChange={(e) => {
                                      setErrorsValidation({
                                        ...errorsValidation,
                                        gender: "",
                                      });
                                      setProfileData({
                                        ...profileData,
                                        gender: e.target.value,
                                      });
                                    }}
                                  >
                                    <option value="">Choose your gender</option>
                                    <option value="1">Male</option>
                                    <option value="2">Female</option>
                                  </select>
                                  {errorsValidation.gender && (
                                    <div className="error">
                                      {errorsValidation.gender}
                                    </div>
                                  )}
                                </div>
                              </div>

                              {/* DOB */}
                              <div className="col-lg-6">
                                <div className="form-group relatives">
                                  <label>Date of Birth</label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    name="dob"
                                    value={profileData.dob}
                                    onChange={handleDateChange}
                                    placeholder="Enter date of birth"
                                    max={new Date().toISOString().split("T")[0]}
                                    onKeyDown={(e) => e.preventDefault()} // Prevent manual typing
                                  />
                                  {errorsValidation.dob && (
                                    <div className="error">
                                      {errorsValidation.dob}
                                    </div>
                                  )}
                                </div>
                              </div>

                              {/* Referral Code */}
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <label>Referral Code</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={profileData.referral_code || ""}
                                    readOnly
                                    style={{ cursor: "not-allowed" }}
                                    placeholder="Enter referral code"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Profile Image */}
                          <div className="col-lg-3">
                            <div id="imgss_upload">
                              <ImageUploader
                                setState={setProfileImage}
                                defaultImage={profileImage}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* ---------------- Organisation Section ---------------- */}
                      <h4>Organisation Details</h4>
                      <div className="mang_und_listst mt-0">
                        <div className="row">
                          {/* Organisation Name */}
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Organisation Name</label>
                              <input
                                maxLength={50}
                                type="text"
                                className={`form-control ${
                                  errorsValidation.organization_name
                                    ? "input-error"
                                    : ""
                                }`}
                                value={profileData.organization_name || ""}
                                onChange={(e) => {
                                  setErrorsValidation({
                                    ...errorsValidation,
                                    organization_name: "",
                                  });
                                  setProfileData({
                                    ...profileData,
                                    organization_name: e.target.value,
                                  });
                                }}
                                placeholder="Enter organisation name"
                              />
                            </div>
                          </div>

                          {/* Location */}
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Location</label>
                              <input
                                type="text"
                                className={`form-control ${
                                  errorsValidation.organization_location
                                    ? "input-error"
                                    : ""
                                }`}
                                value={profileData.organization_location || ""}
                                onChange={(e) => {
                                  setErrorsValidation({
                                    ...errorsValidation,
                                    organization_location: "",
                                  });
                                  setProfileData({
                                    ...profileData,
                                    organization_location: e.target.value,
                                  });
                                }}
                                placeholder="Enter location"
                              />
                            </div>
                          </div>

                          {/* Org Email */}
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Organization Email</label>
                              <input
                                type="text"
                                className={`form-control ${
                                  errorsValidation.organization_email
                                    ? "input-error"
                                    : ""
                                }`}
                                value={profileData.organization_email || ""}
                                placeholder="Enter organization email"
                                onChange={(e) => {
                                  setErrorsValidation({
                                    ...errorsValidation,
                                    organization_email: "",
                                  });
                                  setProfileData({
                                    ...profileData,
                                    organization_email: e.target.value,
                                  });
                                }}
                                // readOnly
                                // style={{ cursor: "not-allowed" }}
                              />
                            </div>
                          </div>

                          {/* Org Mobile */}
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Organization Mobile No.</label>
                              <PhoneInput
                                className={`react-tel-input ${
                                  errorsValidation.organization_mobile_no
                                    ? "input-error"
                                    : ""
                                }`}
                                placeholder="Enter Phone Number"
                                country={"th"}
                                value={profileData.fullMobile || "+66"}
                                onChange={(value, country) => {
                                  setErrorsValidation({
                                    ...errorsValidation,
                                    organization_mobile_no: "",
                                  });

                                  handleMobileChange(value, country);
                                }}
                              />
                            </div>
                          </div>

                          {/* Website */}
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label>Website</label>
                              <input
                                type="text"
                                className={`form-control ${
                                  errorsValidation.organization_website
                                    ? "input-error"
                                    : ""
                                }`}
                                value={profileData.organization_website || ""}
                                onChange={(e) => {
                                  setErrorsValidation({
                                    ...errorsValidation,
                                    organization_website: "",
                                  });
                                  setProfileData({
                                    ...profileData,
                                    organization_website: e.target.value,
                                  });
                                }}
                                placeholder="Website URL"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* ---------------- Social Media Section ---------------- */}
                      <div className="d-flex justify-content-between items-center">
                        <h4 className="m-0">Social Media Links</h4>
                        <button
                          type="submit"
                          className="sub_mitess mr-0 mb-2"
                          disabled={loading}
                          onClick={addSocialMediaField}
                        >
                          + Add Link
                        </button>
                      </div>
                      <div className="mang_und_listst mt-4">
                        <div className="row">
                          {profileData.social_media.map((item, index) => (
                            <div className="row add_mor_lisstst" key={index}>
                              <div className="col-lg-5 col-4">
                                <div className="form-group mb-1">
                                  <select
                                    className="form-control"
                                    value={item.name || "Facebook"} // Ensure default is an empty string
                                    onChange={(e) =>
                                      handleSocialMediaChange(
                                        index,
                                        "name",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="">Select</option>{" "}
                                    {/* Default option */}
                                    <option value="Facebook">Facebook</option>
                                    <option value="Linkedin">Linkedin</option>
                                    <option value="Twitter">Twitter</option>
                                    <option value="Youtube">Youtube</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-lg-5 col-5">
                                <div className="form-group mb-1">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter URL"
                                    value={item.value || ""} // Ensure no undefined value
                                    onChange={(e) =>
                                      handleSocialMediaChange(
                                        index,
                                        "value",
                                        e.target.value
                                      )
                                    }
                                  />
                                  {errors[`social_media_${index}_value`] && (
                                    <small className="text-danger">
                                      {errors[`social_media_${index}_value`]}
                                    </small>
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-2 col-3">
                                <div className="remove_bnt">
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() =>
                                      removeSocialMediaField(index)
                                    }
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* ---------------- Description ---------------- */}
                      <h4 className="mb-2">Description</h4>
                      <div className="mang_und_listst mt-4">
                        <div className="form-group">
                          <label>Add Description</label>
                          <textarea
                            className={`form-control ${
                              errorsValidation.about_organization
                                ? "input-error"
                                : ""
                            }`}
                            rows="5"
                            value={profileData.about_organization || ""}
                            onChange={(e) => {
                              setErrorsValidation({
                                ...errorsValidation,
                                about_organization: "",
                              });
                              setProfileData({
                                ...profileData,
                                about_organization: e.target.value,
                              });
                            }}
                            placeholder="Write about your organization"
                          />
                          {errorsValidation.about_organization && (
                            <span className="error-message">
                              {errorsValidation.about_organization}
                            </span>
                          )}
                        </div>
                      </div>

                      {/* ---------------- Banner Image ---------------- */}
                      <h4 className="mb-2">Upload Images</h4>
                      <div className="mang_und_listst mt-4">
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Banner Image</label>
                            <label className="upload-input upload-control">
                              {bannerImage ? (
                                <img
                                  src={bannerImage} // yaha pe uploaded image ka URL aa jayega
                                  alt="Banner Image"
                                  className="uploaded-image"
                                  style={{
                                    maxWidth: "120px",
                                    maxHeight: "120px",
                                    borderRadius: "8px",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <span className="upload-placeholder">
                                  Choose Banner Image
                                </span>
                              )}
                              <input
                                type="file"
                                name="bannerImage"
                                accept="image/*"
                                onChange={(e) =>
                                  handleFileChange(e, setBannerImage)
                                }
                              />
                              <img
                                className="upload-icon"
                                src="/images/pin.png"
                                alt="attach"
                              />
                            </label>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Company Image</label>
                            <label className="upload-input upload-control">
                              {companyImage ? (
                                <img
                                  src={companyImage} // yaha pe uploaded image ka URL aa jayega
                                  alt="Company Image"
                                  className="uploaded-image"
                                  style={{
                                    maxWidth: "120px",
                                    maxHeight: "120px",
                                    borderRadius: "8px",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <span className="upload-placeholder">
                                  Choose Company Image
                                </span>
                              )}
                              <input
                                type="file"
                                name="companyImage"
                                accept="image/*"
                                onChange={(e) =>
                                  handleFileChange(e, setCompanyImage)
                                }
                              />
                              <img
                                className="upload-icon"
                                src="/images/pin.png"
                                alt="attach"
                              />
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>Company Logo</label>
                          <label className="upload-input upload-control">
                            {companyLogo ? (
                              <img
                                src={companyLogo} // yaha pe uploaded image ka URL aa jayega
                                alt="Company Logo"
                                className="uploaded-image"
                                style={{
                                  maxWidth: "120px",
                                  maxHeight: "120px",
                                  borderRadius: "8px",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <span className="upload-placeholder">
                                Choose Company Logo
                              </span>
                            )}
                            <input
                              type="file"
                              name="companyLogo"
                              accept="image/*"
                              onChange={(e) =>
                                handleFileChange(e, setCompanyLogo)
                              }
                            />
                            <img
                              className="upload-icon"
                              src="/images/pin.png"
                              alt="attach"
                            />
                          </label>
                        </div>
                      </div>

                      {/* ---------------- Submit ---------------- */}
                      <div className="col-lg-12 mt-4 prof_btnnns">
                        <div className="form-group">
                          <button
                            type="submit"
                            className="sub_mitess"
                            disabled={loading}
                          >
                            {loading ? (
                              <ClipLoader color="#fff" size={15} />
                            ) : (
                              "Update Profile"
                            )}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SellerProfile;
